module.exports = __webpack_public_path__ + "img/store-alt.1e780d24.svg";